/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linesheet_Archived_BadgeInputs */

const en_linesheet_archived_badge = /** @type {(inputs: Linesheet_Archived_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Linesheet_Archived_BadgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const linesheet_archived_badge = /** @type {((inputs?: Linesheet_Archived_BadgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linesheet_Archived_BadgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_linesheet_archived_badge(inputs)
});